enum RoleEnum {
  Student = 1,
  Manager = 2,
  Teacher = 3,
  Revisor = 4,
}

export default RoleEnum
